import isEqual from 'lodash/isEqual'
import sortBy from 'lodash/sortBy'
import { toJS } from 'mobx'
import { formatCaseContent } from '../common/CaseDetail/utils'
import { cameraRotateList } from '../constants'

// 处理视频提交数据
export const formatMerchaniseItems = value => {
  const merchandise_items = []
  if (value.cover_video && value.cover_video.link) {
    merchandise_items.push({
      media_path: value.cover_video.link,
      kind: 2, // 1：图片  2：视频
      persistent_id: value.cover_video.persistent_id,
      cover_path: value.cover_video.cover_path,
      width: value.cover_video.width,
      height: value.cover_video.height,
      is_head: 1,
      id: value.cover_video?.id
    })
  }
  return merchandise_items
}

// 数据处理 丢utils
export const formatSetMealDetail = value => {
  return (value.case_content || []).map(item => {
    const { type, id } = item
    let content = {}
    switch (type) {
      case 'img':
        content = {
          kind: 1,
          id: id,
          content: {
            media_path: item.link,
            text: item.text,
            width: item.width,
            height: item.height
          }
        }
        break

      case 'video':
        content = {
          kind: 2,
          persistent_id: item.persistent_id,
          id: item.id,
          content: {
            media_path: item.link,
            text: item.text,
            cover_path: item.cover_path,
            width: item.width,
            height: item.height
          }
        }
        break
      case 'title':
        content = {
          kind: 3,
          id: item.id,
          content: {
            title: item.title,
            text: item.text
          }
        }
        break
    }
    return content
  })
}

/**
 * @title 处理setMealItems数据提交格式
 */
export const formatSetMealItems = value => {
  const caseReference = value.caseReference
  const set_meal_items = [
    {
      name: '婚礼日期',
      describe:
        value['wedding_date'] && value['wedding_date'].format('YYYY-MM-DD')
    },
    {
      name: '婚礼地点',
      describe: value['hotel_name'],
      merchant_id: value['hotel_id'],
      hotel_hall_id: value['hotel_hall_id']
    },
    {
      name: '参考价格',
      describe: caseReference
    }
  ]
  return set_meal_items
}

/**
 * @title 判断form表单的值是否修改改：true：改变；false：未改。value为提交值
 */
export const isChange = (
  new_tag_ids,
  set_meal_detail,
  case_detail,
  isChanged,
  selectedTopWeddingTag,
  selectedTopWeddingTagFrozen
) => {
  let flag = isChanged
  // 对比案例属性
  const tagIds = case_detail.tags.map(item => item.mark_id)
  if (JSON.stringify(sortBy(new_tag_ids)) != JSON.stringify(sortBy(tagIds))) {
    flag = true
  }

  const meal_detail = case_detail.set_meal_detail
  // 对比案例详情信息
  if (
    !isChangeCaseDetail(
      formatCaseContent(toJS(meal_detail)),
      toJS(set_meal_detail)
    )
  ) {
    flag = true
  }

  if (
    !isEqual(toJS(selectedTopWeddingTag), toJS(selectedTopWeddingTagFrozen))
  ) {
    // 对比高定标签
    flag = true
  }
  return flag
}

/**
 * @description 处理提交的图片和视频格式
 */
export const formatImageVideo = arr => {
  if (!arr || !arr.length) {
    return []
  }
  return arr?.map(e => {
    if (e.type.includes('image')) {
      return {
        type: 1,
        photo: {
          path: e.url,
          width: e.width || e.response?.width,
          height: e.height || e.response?.height
        }
      }
    } else {
      return {
        type: 2,
        video: {
          path: e.url,
          width: e.width || e.response?.avinfo?.video?.coded_width,
          height: e.height || e.response?.avinfo?.video?.coded_height
        }
      }
    }
  })
}

/**
 * @title 寻找城市code和省级
 */
export const findCity = (name, all) => {
  let citycode = ''
  let provice = {}
  const allCity = toJS(all)
  for (let i in allCity) {
    for (let j in allCity[i].children) {
      if (allCity[i].children[j].label == name) {
        citycode = allCity[i].children[j].key
        provice = allCity[i]
      }
    }
  }
  return {
    citycode,
    provice
  }
}

/**
 * @title 案例正文类型
 */
export const getCaseContentType = type =>
  ({ 1: 'img', 2: 'video', 3: 'title' }[+type])

/**
 * @title 校验图片宽度
 */
export const checkImageWidth = ({ width, height, orientation }) => {
  const isRotate = orientation && cameraRotateList.includes(orientation.val)
  const calcHeight = !isRotate ? height : width
  return calcHeight < 8192
}

/**
 * @title 格式化案例详情图片数据格式
 */

export const getImgItem = (link, { width, height, orientation }) => {
  const isRotate = orientation && cameraRotateList.includes(orientation.val)
  return {
    type: 'img',
    link,
    width: !isRotate ? width : height,
    height: !isRotate ? height : width
  }
}

/**
 * @title 对比案例详情信息前后是否有改动
 */

export const isChangeCaseDetail = (prevCase, currentCase) => {
  return isEqual(prevCase, currentCase)
}
